import React, { ReactNode } from "react"
import { Badge as BadgeType } from "@warp/types/product"
import { StarIcon } from "./StarIcon"
import { DiscountIcon } from "./DiscountIcon"
import { ColoursIcon } from "./ColoursIcon"
import { isMultipleBadge, isSingleBadge } from "./utils"

type PropType = {
  badge: BadgeType
  variantId?: number
  children?: ReactNode
}

const renderBadgeIcon = (key: string) => {
  switch (key) {
    case "new":
      return <StarIcon />
    case "on_sale":
    case "variants_on_sale":
      return <DiscountIcon />
    case "colours":
      return <ColoursIcon />
    default:
      return null
  }
}

const Badge = ({ badge, children, variantId }: PropType) => {
  if (
    !badge.key ||
    (isSingleBadge(badge) && !badge.value) ||
    (isMultipleBadge(badge) && badge.values.length === 0)
  ) {
    return null
  }

  const text = isSingleBadge(badge)
    ? badge.value
    : badge.values.find((value) => value.variantId === variantId)?.text

  if (!text) {
    return null
  }

  const badgeIcon = renderBadgeIcon(badge.key)
  const badgeIconClasses = `badge__icon badge__icon--${badge.key}`

  return (
    <div
      className={`badge ${badge.position ? `badge--${badge.position}` : ""}`}
    >
      {children ? (
        <>
          <span className={badgeIconClasses}>{children}</span>
          <span
            data-badge-key={badge.key}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </>
      ) : (
        <>
          <span className={badgeIconClasses}>{badgeIcon}</span>
          <span
            className="badge__text"
            data-badge-key={badge.key}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </>
      )}
    </div>
  )
}

export default Badge
